export interface AliceSession {
  id: string;
  title: string;
  messages: AliceMessage[];

  useProject?: boolean
}

export interface AliceProgressItem {
  message: string;
  agentName?: string;
  source?: string;
  createdAt?: string;
}

export interface AliceMessage {
  id: string;
  prompt: string;
  answer: string;
  liked: boolean;
  notLiked: boolean;
  comment: string;
  traceId: string;
  videoId?: string;
  timestamp?: string;
  flowsurveyId?: string;
  nodeId?: string;
  base64?: string;
  fileBase64?: string;
  fileName?: string;
  fileMimeType?: string;
  status?: string;
  progress?: AliceProgressItem[];
  alert?: boolean;
  alertMessage?: string;
}

export interface AliceKeyValueExternalConnector {
  type: AliceKeyValueExternalConnectorTypeEnum;
  id?: string;
  clientId?: string;
  datasetName?: string;
  datasetDescription?: string;
  googleCloudApiKey?: string;
  googleCloudProjectId?: string;
  host?: string;
  port?: number;
  databaseName?: string;
  schemaName?: string;
  username?: string;
  password?: string;
  passwordSet?: boolean;
  description?: string;
  sslEnabled?: boolean;
}

export enum AliceKeyValueExternalConnectorTypeEnum {
  BIG_QUERY = "BIG_QUERY",
  POSTGRES = "POSTGRES"
}

export interface AliceKeyValueConfig {
  id: string;
  name: string;
  value: string;
  type: AliceKeyValueConfigEnum;
  externalConnector?: AliceKeyValueExternalConnector;
  referencedConnectorId?: string;
}

export interface PostgresConnectionTestRequest {
  host: string;
  port: number;
  databaseName: string;
  schemaName?: string;
  username: string;
  password: string;
  sslEnabled?: boolean;
}

export enum AliceKeyValueConfigEnum {
  TABLE_DEFINITION = 'TABLE_DEFINITION',
  EXTERNAL_CONNECTOR = 'EXTERNAL_CONNECTOR',
  EXCLUDE_PAGES_FROM_INDEX = 'EXCLUDE_PAGES_FROM_INDEX',
  NOT_TO_INDEX = 'NOT_TO_INDEX',
  ASSISTANT_AVATAR = 'ASSISTANT_AVATAR',
  ASSISTANT_NAME = 'ASSISTANT_NAME',
  AI_REQUEST_GROUPS = 'AI_REQUEST_GROUPS',
  AI_REPORT_GROUPS = 'AI_REPORT_GROUPS',
  RELEVANT_SEARCH_IGNORE_HOMEPAGE = 'RELEVANT_SEARCH_IGNORE_HOMEPAGE',
}

export interface AliceTraceFilter {
  clientId?: string,
  userId?: string,
  startedAt?: string,
  finishedAt?: string,
  liked?: boolean,
  notLiked?: boolean,
  intentionName?: string
}

export interface AliceTraceSummary {
  userId: string;
  id: string;
  input: string;
  output: string;
  totalTokens: number;
  startedAt: string;
  finishedAt: string;
  latency: number;
}

export interface AliceTraceItem extends AliceTraceSummary {
  modelProvider: string;
  modelName: string;
  type: string;
  inputTokens: number;
  outputTokens: number;

  inputParsed?: any
  outputParsed?: any
}

export interface AliceTrace extends AliceTraceItem {
  items: AliceTraceItem[];
}

export interface ToolExecutionRequest {
  id: string;
  name: string;
  arguments: any;
}

export interface Message {
  type: string;
  text?: string;
  name?: string;
  contents?: { text: string }[];
  toolExecutionRequests?: ToolExecutionRequest[];
}

export interface AliceProject {
  description: string;
  homePageId: null;
  id: string;
  master: boolean;
  name: string;
  prompt: string;
}

export interface AliceQuotaUsageDetail {
  id: string;
  clientId: string;
  userId: string;
  userName?: string;
  user?: { fullName?: string };
  yearMonth: string | number[];
  questionCount: number;
  monthlyFreeQuestions: number;
  usagePercentage: number;
  customLimit?: boolean;
  clientMonthlyFreeQuestions?: number;
}

export interface AliceQuotaUsageResponse {
  content: AliceQuotaUsageDetail[];
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      sorted: boolean;
      unsorted: boolean;
      empty: boolean;
    };
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalPages: number;
  totalElements: number;
  last: boolean;
  first: boolean;
  size: number;
  number: number;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  numberOfElements: number;
  empty: boolean;
}

